import { Nilable } from "@shared/utils";

export interface IBigmlAnswersDTO {
    answers_list: Nilable<IBigmlAnswerDTO[]>;
}

export class BigmlAnswersDTO {
    public answersList: BigmlAnswerDTO[] = [];

    constructor(json: Nilable<Partial<IBigmlAnswersDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlAnswersDTO>) {
        if (json.answers_list != null) {
            this.answersList = json.answers_list.map(answer => new BigmlAnswerDTO(answer));
        }
    }

    public toJSON(): IBigmlAnswersDTO {
        return {
            answers_list: this.answersList.map(answer => answer.toJSON())
        };
    }
}

export interface IBigmlAnswerDTO {
    id: Nilable<number>;
    text: Nilable<string>;
    total_times_answered: Nilable<number>;
    average: Nilable<number>;
}

export class BigmlAnswerDTO {
    public id = 0;
    public text = "";
    public totalTimesAnswered = 0;
    public average = 0;

    constructor(json: Nilable<Partial<IBigmlAnswerDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlAnswerDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.text != null) {
            this.text = json.text;
        }
        if (json.total_times_answered != null) {
            this.totalTimesAnswered = json.total_times_answered;
        }
        if (json.average != null) {
            this.average = json.average;
        }
    }

    public toJSON(): IBigmlAnswerDTO {
        return {
            id: this.id,
            text: this.text,
            total_times_answered: this.totalTimesAnswered,
            average: this.average
        };
    }
}
